import { HTMLAttributes } from "react";
import { Checkbox, AutocompleteRenderOptionState } from "@mui/material";

interface RenderOptionProps {
  props: HTMLAttributes<HTMLLIElement>;
  option: string;
  state: AutocompleteRenderOptionState;
}

export function RenderOption({ props, option, state }: RenderOptionProps) {
  return (
    <li {...props}>
      <Checkbox
        size="small"
        checked={state.selected}
        sx={{ padding: 0, paddingRight: "5px", margin: 0 }}
      />
      {option}
    </li>
  );
}
